export default "__VITE_ASSET__CbEufqKd__"